import CaseStudyFeed from './CaseStudyFeed'

export default CaseStudyFeed
